import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  DOWNLOAD_CSV,
  FETCH_CSV_HISTORY,
  GET_ROW_ID_STATUS,
  STOP_FILE_HISTORY_POLLING
} from 'redux/sagas/actions/lead';

import { Table } from 'ui/atoms';

import { HistoryTableContainer } from './style';

const historyColumns = [
  {
    accessor: 'icon',
    contentType: 'icon',
    iconType: 'icon-icon-file',
    position: 'center',
    width: '0.5fr',
    size: '24'
  },
  {
    accessor: 'fileName',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '2.5fr'
  },
  {
    accessor: 'uploadDate',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '1.5fr'
  },
  {
    accessor: 'fileStatus',
    contentType: 'icon',
    headerType: 'text',
    position: 'center',
    width: '1fr',
    size: '24'
  },
  {
    accessor: 'action',
    contentType: 'downloadable',
    iconType: 'icon-download1',
    position: 'center',
    width: '0.5fr',
    size: '24',
    showTooltip: true,
    toolTipText: 'Download the file to fix errors before upload it again.'
  }
];

const LeadHistory = ({
  fetchCSVHistory,
  historyList,
  downloadCSVFile,
  getRowIDStatus,
  fileDataList,
  stopPollCSVHistory
}) => {
  useEffect(() => {
    fetchCSVHistory();
    return stopPollCSVHistory;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getFileRowStatus = filename => {
    getRowIDStatus(filename);
  };

  const onIconClick = (accessor, rowData) => {
    downloadCSVFile(rowData.fileName);
  };

  return (
    <HistoryTableContainer>
      <Table
        data={historyList}
        headerColumns={historyColumns}
        isRowExpandable
        onExpandRow={getFileRowStatus}
        expandedRowData={fileDataList}
        rowDivider
        variant="fileHistoryPeopleLeads"
        onDownloadFile={onIconClick}
        selection={false}
        size={24}
      />
    </HistoryTableContainer>
  );
};

LeadHistory.propTypes = {
  historyList: PropTypes.array,
  fetchCSVHistory: PropTypes.func,
  downloadCSVFile: PropTypes.func,
  getRowIDStatus: PropTypes.func,
  fileDataList: PropTypes.array,
  stopPollCSVHistory: PropTypes.func
};

export default connect(
  state => ({
    historyList: state?.lead?.historyList || [],
    fileDataList: state?.lead?.fileDataList || []
  }),
  dispatch => ({
    fetchCSVHistory: () => dispatch({ type: FETCH_CSV_HISTORY._REQUEST }),
    downloadCSVFile: fileName =>
      dispatch({
        type: DOWNLOAD_CSV._REQUEST,
        payload: { fileName }
      }),
    getRowIDStatus: fileName =>
      dispatch({
        type: GET_ROW_ID_STATUS._REQUEST,
        payload: { fileName }
      }),
    stopPollCSVHistory: () =>
      dispatch({ type: STOP_FILE_HISTORY_POLLING._REQUEST })
  })
)(LeadHistory);
